import '@banno/jha-wc/src/progress/jha-progress/jha-progress.js';
import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { TmBaseComponent } from '../../tm-base.component';

const tagName = 'tm-jh-progress';
@customElement(tagName)
export class TmProgress extends TmBaseComponent {
    protected render() {
        return html`
            <div class="card-loading">
                <jha-progress type="circular" size="large" indeterminate></jha-progress>
            </div>
        `;
    }

    public static get styles() {
        return css`
            .card-loading {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 32px 0;
                min-height: 200px;
            }
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmProgress;
    }
}
